import StarterpackDetail from './StarterpackDetail';
export default StarterpackDetail;



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/components/StarterpackDetail/components/StarterpackDetail/index.ts